module.exports = __webpack_public_path__ + "static/media/404_glitch2.119ecb7e.gif";